export const ConsumerSubmitFormStyles = {
  formContainer: 'w-full mb-3 sm:max-w-xl',
  buttonWrapper: 'w-full flex flex-col items-center',
  submitButtonContainer: 'justify-center text-xl sm:text-2xl',
  submitButton: 'sm:max-w-sm',
}
